<template>
    <video
      id="welcome-video"
      :poster="posterUrl"
      playsinline
      controls
      class="video"
      :style="{maxHeight:`${maxHeight}px`}"
    >
      <source :src="videoUrl" />
    </video>
</template>

<script>
export default {
  props: {
    maxHeight: {
      type: Number,
      default: 390
    }
  },
  data() {
    return {
      videoUrl:
        "https://pjili-public.s3.ca-central-1.amazonaws.com/auctions/assets/videos/Welcome+Video.mp4",
      posterUrl:
        "https://pjili-public.s3.ca-central-1.amazonaws.com/auctions/assets/img/welcome_poster.png",
    }
  },
}
</script>

<style lang="scss">
video#welcome-video {
  width: 100%;
  min-width: 100%;
  object-fit: cover;
  cursor: pointer;
}
</style>